import { render, staticRenderFns } from "./ERealEstateView.vue?vue&type=template&id=083c28a4&scoped=true&"
import script from "./ERealEstateView.vue?vue&type=script&lang=js&"
export * from "./ERealEstateView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083c28a4",
  null
  
)

export default component.exports